import { BaseComponentLocator } from './base.component-locator';
export class DisciplineLocatorComponent extends BaseComponentLocator {
    constructor() {
        super(...arguments);
        this.outdoorCode = 1;
        this.indoorCode = 2;
        this._id = null;
    }
    toString() {
        let label = 'inoutdoor';
        if (this.id === this.outdoorCode) {
            label = 'outdoor';
        }
        else if (this.id === this.indoorCode) {
            label = 'indoor';
        }
        return label;
    }
    /**
     * disciplineId setter/getter.
     */
    set id(disciplineId) {
        this._id = disciplineId;
    }
    get id() {
        return this._id;
    }
    /**
     *
     */
    setOutdoor() {
        this.id = this.outdoorCode;
    }
    setIndoor() {
        this.id = this.indoorCode;
    }
}
